import styles from '../components/main.module.css';

export default function Main() {
    
    return (
        <div className={styles.main}>
            <div className={styles.title}>
                <h1>Welcome United Dogs 🐶</h1>
            </div>
        </div>
    )
}